import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
import { consentCookieHelper } from '@sainsburys-tech/boltui-utils';
import useInterval from './useInterval';

var handleLegacyCookie = function handleLegacyCookie(cookieString, categoryName, cookieName) {
  var consentCookieValue = consentCookieHelper.getConsentCookieValue(cookieString, cookieName);

  if (consentCookieValue === '') {
    return null;
  } // Return false in case invalid cookie value or invalid category passed in


  if (!consentCookieValue.includes('consent:') || !consentCookieHelper.categories[categoryName]) {
    return false;
  }

  var categorySection = consentCookieHelper.getCategorySection(consentCookieValue, categoryName); // If can't find section, then all cookies were accepted (example value: 'ts:1575020721807|consent:true')

  if (!categorySection.length && consentCookieValue.includes('consent:true')) {
    return true;
  }

  return consentCookieHelper.hasOptedIn(categorySection[0]);
};

var handleOptanonCookie = function handleOptanonCookie(cookieString, categoryName) {
  var optanonCookieValue = consentCookieHelper.getConsentCookieValue(cookieString, consentCookieHelper.optanonCookieName); // Optanon cookies are set with default values assuming no consent,
  // so we need intType to detect actual user interaction

  if (!optanonCookieValue.includes('intType=')) {
    return null;
  } // Return false in case invalid category passed in


  if (!consentCookieHelper.optanonCategories[categoryName]) {
    return false;
  }

  return consentCookieHelper.hasOptanonOptedIn(optanonCookieValue, categoryName);
};

var getCookieConsent = function getCookieConsent(categoryName, cookieName) {
  var cookies = global.document.cookie;
  var consentResult; // Prefer Optanon cookie if it exists

  if (consentCookieHelper.hasOptanonCookie(cookies)) {
    consentResult = handleOptanonCookie(cookies, categoryName);
  } else {
    // Fall back to Tealium cookie
    consentResult = handleLegacyCookie(cookies, categoryName, cookieName);
  }

  return consentResult;
};

function useCookieConsent(category) {
  var consentCookie = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : consentCookieHelper.cookieName;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      hasConsent = _useState2[0],
      setHasConsent = _useState2[1]; // Get cookie on mount


  useEffect(function () {
    setHasConsent(getCookieConsent(category, consentCookie));
  }, [category, consentCookie]); // Check for cookie value every second until user has interacted

  useInterval(function () {
    setHasConsent(getCookieConsent(category, consentCookie));
  }, 1000, hasConsent !== null);
  return hasConsent;
}

export default useCookieConsent;